import React, { useState } from "react";
import { AtsRfqMstEdge } from "../../../quotation/queries/types";
import RFQAutocomplete from "./RFQAutocomplete";
import DataFetch from "../../../../../../../images/OpenIcon.svg";
import RfqDetails from "../RfqDetails";
import { ViewModalStyles } from "../../../../../../../styles/CustomModalStyles";
import { CustomModal } from "../../../../../../../utils/UtilFunctions";

export interface Props {
  onChange: (newValue: AtsRfqMstEdge | null) => void;
  value: AtsRfqMstEdge | null;
  autofocus?: boolean;
  onKeyDown?:
    | ((
        event: React.KeyboardEvent<HTMLDivElement> & {
          defaultMuiPrevented?: boolean;
        }
      ) => void)
    | undefined;
}
const RFQSelect = ({ onChange, value, autofocus, onKeyDown }: Props) => {
  const [rfqDetails, setRfqDetails] = useState(false);

  return (
    <>
      <RFQAutocomplete
        onChange={onChange}
        onKeyDown={onKeyDown}
        autofocus={autofocus}
        value={value}
      />
      <img
        src={DataFetch}
        alt=""
        className="data-fetch-icon"
        onClick={() => setRfqDetails(!rfqDetails)}
      />

      <CustomModal
        isOpen={rfqDetails}
        onRequestClose={() => setRfqDetails(false)}
        contentComponent={
          <RfqDetails setModalFlag={setRfqDetails} onSelect={onChange} />
        }
        style={ViewModalStyles}
      />
    </>
  );
};

export default RFQSelect;
